<ng-container *ngIf="init$ | async as init">
  <app-loading *ngIf="init.isLoading"></app-loading>
  <app-error *ngIf="init.error as error" [error]="error"></app-error>

  <ng-container *ngIf="init.didSucceed">
    <app-page [dynamicHeight]="true" class="page-wrapper">
      <app-header>
        <h1 app-overline>Summary</h1>
        <h2 app-title>Simulation summary</h2>
      </app-header>

      <mat-divider></mat-divider>

      <app-edit-page>
        <h3 app-heading>Pattern Configurations</h3>
        <app-slideshow
          *ngIf="stagedPatterns?.length > 0; else noContent"
          app-content
          [inputArray]="stagedPatterns"
          (focusedElement)="currentPattern = $event"
        >
          <app-card-pattern-config
            [pattern]="currentPattern"
          ></app-card-pattern-config>
        </app-slideshow>
      </app-edit-page>

      <app-edit-page>
        <h3 app-heading>Hardware Configurations</h3>
        <app-slideshow
          *ngIf="stagedPatterns?.length > 0; else noContent"
          app-content
          [inputArray]="stagedHardware"
          (focusedElement)="currentHw = $event"
        >
          <app-card-hardware-display
            [hwConfig]="currentHw"
          ></app-card-hardware-display>
        </app-slideshow>
      </app-edit-page>

      <app-edit-page [bottomDivider]="false">
        <h3 app-heading>Software Configurations</h3>
        <app-slideshow
          *ngIf="stagedPatterns?.length > 0; else noContent"
          app-content
          [inputArray]="stagedSoftware.concat(stagedSoftwarePresets)"
          (focusedElement)="currentSw = $event"
        >
          <app-card-software-display [swConfig]="currentSw">
          </app-card-software-display>
        </app-slideshow>
      </app-edit-page>
      <ng-template #noContent>
        <div app-content>
          <span><i> Please select one. </i></span>
        </div>
      </ng-template>
    </app-page>
  </ng-container>
</ng-container>
